import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import _ from 'lodash';
import { t } from '../../../../locales';
import { isApp, resolvePublicAssets } from '../../../../utils';
import EmmaNavTitle from '../../../../components/EmmaNavTitle';
import './style.scss';
import EmmaItem from '../../../../components/EmmaItem';
import Calendar from '../../../../components/Calendar';
import {
  getCampaignDetail,
  getAxagoalIsFirstYear,
  getAktivoStepStats,
} from '../../selectors/vhisSelectors';
import {
  showAxaGoalSupport,
  fetchAktivoStepStats,
} from '../../actions/vhisAction';

interface RecordProps {
  recordModel: any;
  campaignDetail: any;
  match: {
    params: {
      month: string;
      achieveDays: string;
      entityCode: string;
      ruleType: 'SH' | 'WGP';
    };
  };
  aktivoStepStats: any;
  onShowAxaGoalSupport: (entityCode: string, ruleType: 'SH' | 'WGP') => void;
  fetchAktivoSteps: (startDate, endDate) => void;
}

export interface RecordState {
  searchDate: Date;
  achieveDays: any;
}

class Record extends Component<RecordProps, RecordState> {
  constructor(props: any) {
    super(props);
    let { month, achieveDays } = this.props?.match?.params || {};
    month = month?.replace('-', '/');
    this.state = {
      searchDate: new Date(`${month}/1`),
      achieveDays,
    };
  }

  componentDidMount(): void {
    const { fetchAktivoSteps, campaignDetail } = this.props;
    const { searchDate: firstDateOfCurrentMonth } = this.state;
    const currentYear = firstDateOfCurrentMonth.getFullYear();
    const firstDayOfCurrentYear = new Date(currentYear, 0, 1);
    const lastDayOfCurrentYear = new Date(currentYear, 11, 31);
    fetchAktivoSteps(firstDayOfCurrentYear, lastDayOfCurrentYear);
  }

  render() {
    const { searchDate, achieveDays } = this.state;
    const { campaignDetail, onShowAxaGoalSupport, aktivoStepStats } =
    this.props;
    const { entityCode = 'LHK', ruleType } = this.props.match.params;
    const { startDate, endDate, achievedDates } = campaignDetail;
    const silverHairTextPrefix = ruleType === 'SH' ? 'SH_' : '';
    const achievedDayDotItemLeft = (
      <div className="record-container-content-tips-item__img">
        <img
          src={resolvePublicAssets(`assets/images/icon-li-dot.svg`)}
          alt=""
        />
      </div>
    );
    const nonAchievedDayDotItemLeft = (
      <div className="record-container-content-tips-item__img">
        <img
          src={resolvePublicAssets(`assets/images/icon-li-dot-yellow.svg`)}
          alt=""
        />
      </div>
    );
    const processingDataDotItemLeft = (
      <div className="record-container-content-tips-item__img">
        <img
          src={resolvePublicAssets(`assets/images/icon-li-dot-silver.svg`)}
          alt=""
        />
      </div>
    );
    const achievedDayDotItemRight = (
      <div className="record-container-content-tips-item__span">
        {t(`${silverHairTextPrefix}AXA_GOAL_RECORD_ACHIEVED_DAY`)}
      </div>
    );
    const nonAchievedDayDotItemRight = (
      <div className="record-container-content-tips-item__span">
        {t(`${silverHairTextPrefix}AXA_GOAL_RECORD_NON_ACHIEVED_DAY`)}
      </div>
    );
    const dataProcessingDayDotItemRight = (
      <div className="record-container-content-tips-item__span">
        {t('AXA_GOAL_RECORD_DATA_PROCESSING_DAY')}
      </div>
    );
    const emmaStartItemleft = (
      <div className="record-container-content-tips-item-start">
        <div className="record-container-content-tips-item-start-span">
          {t('AXA_GOAL_RECORD_START')}
        </div>
      </div>
    );
    const emmaStartItemRight = (
      <div className="record-container-content-tips-item__span">
        {t('AXA_GOAL_RECORD_START_DAY')}
      </div>
    );
    const emmaEndItemleft = (
      <div className="record-container-content-tips-item-end">
        <div className="record-container-content-tips-item-end-span">
          {t('AXA_GOAL_RECORD_END')}
        </div>
      </div>
    );
    const emmaEndItemRight = (
      <div className="record-container-content-tips-item__span">
        {t('AXA_GOAL_RECORD_END_DAY')}
      </div>
    );
    const calendarProps = {
      today: searchDate,
      achievedDates,
      startDate,
      endDate,
      achievedDatesNumber: achieveDays,
      aktivoStepStats,
    };
    return (
      <div className="record-container">
        <div className="emma-stylesheet-grid-system">
          <EmmaNavTitle
            title={t('AXA_GOAL_RECORD_TITLE')}
            component={
              <div className="record-container__title">
                {t('AXA_GOAL_RECORD_TITLE')}
              </div>
            }
          />
          <div className="record-container-content content-align-vertical">
            <div className="record-container-content-calendar">
              <Calendar {...calendarProps} />
            </div>
            <div className="record-container-content-tips">
              <EmmaItem
                emmaItemClass={`record-container-content-tips-item`}
                leftComponent={achievedDayDotItemLeft}
                rightComponent={achievedDayDotItemRight}
              />
              <EmmaItem
                emmaItemClass={`record-container-content-tips-item`}
                leftComponent={nonAchievedDayDotItemLeft}
                rightComponent={nonAchievedDayDotItemRight}
              />
              <EmmaItem
                emmaItemClass={`record-container-content-tips-item`}
                leftComponent={processingDataDotItemLeft}
                rightComponent={dataProcessingDayDotItemRight}
              />
              <EmmaItem
                emmaItemClass={`record-container-content-tips-item`}
                leftComponent={emmaStartItemleft}
                rightComponent={emmaStartItemRight}
              />
              <EmmaItem
                emmaItemClass={`record-container-content-tips-item`}
                leftComponent={emmaEndItemleft}
                rightComponent={emmaEndItemRight}
              />
            </div>
          </div>
          <div className="record-container-footer content-align-vertical">
            <div className="record-container-footer-title">
              {t('AXA_GOAL_RECORD_PROBLEM')}
            </div>
            <div className="record-container-footer-button">
              <button
                className="emma-stylesheet-primary-ghost-button"
                data-enable-ga
                data-ga-type="button"
                onClick={() => onShowAxaGoalSupport(entityCode, ruleType)}
              >
                {t('AXA_GOAL_RECORD_SUPPORT')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const recordModel = '';
    const isFirstYear = getAxagoalIsFirstYear(state);
    const campaignDetail = getCampaignDetail(state, isFirstYear);
    const aktivoStepStats = getAktivoStepStats(state);
    return {
      recordModel,
      campaignDetail,
      aktivoStepStats,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onShowAxaGoalSupport: (entityCode: string, ruleType: 'SH' | 'WGP') =>
        dispatch(showAxaGoalSupport(entityCode, ruleType)),
      fetchAktivoSteps: (startDate: string, endDate: string) =>
        dispatch(
          fetchAktivoStepStats({
            startDate,
            endDate,
          }),
        ),
    };
  }
}

export default connect(
  Record.mapStateToProps,
  Record.mapDispatchToProps,
)(Record);
